import { useEffect, useRef } from 'react';
// import { toAbsoluteUrl } from '../../../../../_metronic/helpers';
import { useIntl } from 'react-intl';
import '../../../auth/styles/auth_layout.scss';
// install lottie web using --> npm install lottie-web
import lottie from 'lottie-web';
import animationData from '../../../../../media/auth/loader-anim.json';

const Lottie = ({ animationData }:any) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const animation = lottie.loadAnimation({
      container: containerRef.current as Element,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: animationData
    });

    // Cleanup animation on component unmount
    return () => {
      animation.destroy();
    };
  }, [animationData]);

  return <div ref={containerRef} style={{ width: '250px', height: '250px', margin: 'auto' }}></div>;
};

export const Loader = ({isTeamMember}:any) => {
  const { formatMessage } = useIntl();

  return (
    <div className='d-md-flex flex-md-column justify-content-md-center align-items-md-center m-20'>
      <div>
        {/* <img src={toAbsoluteUrl('/media/auth/loader.svg')} alt='Loader' /> */}
        <Lottie animationData={animationData} />
      </div>
      <div className='fs-4 fw-bold mt-5'>{formatMessage({ id: 'Please wait...' })}</div>
      {isTeamMember && (
        <div className='text-gray-500 fs-6 text-center'>
          {formatMessage({ id: 'We are taking you to your dashboard.' })} <br />
          {formatMessage({
            id: 'You can start managing your fund raising process immediately'
          })}
        </div>
      )}
    </div>
  );
};
